import _ from "lodash";
import ApiRequest from "@/helpers/ApiRequest";
import { DELETE_POOL, SAVE_POOLS } from "@/store/mutation-types";
import GetHeaders from "../../helpers/GetHeaders";

export default {
  actions: {
    addPool: async ({ dispatch }, payload) => {
      return ApiRequest.explorePost(
        "pools",
        {
          name: payload.obj.name,
          sourcetype: payload.obj.source,
          description: payload.obj.description,
          uploads: [] // Post empty array for now to prevent validation error
        },
        GetHeaders.projectHeaders()
      )
        .then(res => {
          if(!("refresh" in payload.obj)){
            dispatch("loadPools");
          }
          return res;
        })
        .catch(response => {
          console.log(response);
        });
    },
    deletePool: async ({ dispatch }, payload) => {
      return ApiRequest.exploreDelete(
        "pools/" + payload.id,
        GetHeaders.projectHeaders()
      )
        .then(() => {
          dispatch("loadPools");
          return true;
        })
        .catch(error => {
          return error.response.data.detail;
        });
    },
    updatePool: async ({ dispatch }, payload) => {
      console.log(payload.id);
      return ApiRequest.explorePost(
        "pools/" + payload.id,
        {
          poolid: payload.pool.poolid,
          name: payload.pool.name,
          description: payload.pool.description,
          sourcetype: payload.pool.dbtype,
          uploads: payload.pool.uploaddata,
          isimport: payload.pool.isimport,
          query: payload.pool.query || null
        },
        GetHeaders.projectHeaders()
      )
        .then(res => {
          if(!("refresh" in payload.pool)){
            dispatch("loadPools");
          }
          return res;
        })
        .catch(response => {
          console.log(response);
        });
    },
    processPool: async (_, payload) => {
      return ApiRequest.explorePost(
        "processpool/" + payload.id,
        {
          name: payload.filename
        },
        GetHeaders.projectHeaders()
      )
        .then(res => {
          return res;
        })
        .catch(response => {
          console.log(response);
        });
    },
    deletePoolDoc: async (_, payload) => {
      return ApiRequest.explorePost(
        "poolsdoc/" + payload.id,
        {
          doc_id: payload.doc
        },
        GetHeaders.projectHeaders()
      )
        .then(() => {
          return true;
        })
        .catch(error => {
          return error.response.data.detail;
        });
    },
    loadPool: async (_, payload) => {
      return ApiRequest.exploreGet(
        "pools/" + payload.id,
        GetHeaders.projectHeaders()
      ).then(res => {
        return res.data;
      });
    },
    loadPools: async ({ commit }) => {
      return ApiRequest.exploreGet("pools", GetHeaders.projectHeaders()).then(
        res => {
          commit(SAVE_POOLS, { pools: res.data });
        }
      );
    }
  },
  getters: {
    poolById: state => payload => state.pools.find(p => p._id === payload.id),
    poolsByDateDesc: state => _.orderBy(state.pools, "creationDate", "desc")
  },
  mutations: {
    [SAVE_POOLS](state, payload) {
      state.pools = payload.pools;
    },
    [DELETE_POOL](state, payload) {
      const i = state.pools.findIndex(v => v.id === payload.id);
      state.pools.splice(i, 1);
    }
  },
  state: {
    pools: []
  }
};
